import { CheckIcon } from '@heroicons/react/24/solid';
import { FieldError } from './FieldError.js';

export function Checkbox({
  name = 'hasTerms',
  checked,
  onChange,
  hasError,
  error,
  children,
}) {
  const handleToggle = () => {
    onChange({ target: { name, value: !checked } });
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="size-5 border rounded flex items-center justify-center bg-white border-charcoal-200"
          aria-pressed={checked}
          onClick={handleToggle}
        >
          <CheckIcon
            className={`size-5 text-charcoal-900 stroke-2 transition-opacity ${
              checked ? '' : 'opacity-0'
            }`}
          />
        </button>
        {children}
      </div>
      <FieldError error={error} />
    </>
  );
}
